// extracted by mini-css-extract-plugin
export default {"fullPage":"StackPage_fullPage__NWQ0j","iconContainer":"StackPage_iconContainer__nc5D2"};